import * as React from 'react';
import { useContext, useState, useEffect, useMemo } from 'react';
import { LoginStateContext } from '../../../../Login/Contexts/LoginStateContext/LoginStateContext';
import SchedulerComponent, {
  BookingsObject,
} from './Components/SchedulerComponent/SchedulerComponent';

import { IExtendedBusinessDataProps } from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataSet/BusinessDataSet';
import { ActiveRoutineContext } from '../../../../Routing/ActiveRoutine/ActiveRoutineContext';
import { IBokningsrubrik } from './Utils/KalenderTypes';
import {
  BOGetXBridgeBookingsQuery,
  BOGetXBridgeBookingsQueryVariables,
} from './Queries/XbridgeQuery/_QueryTypes/BOGetXBridgeBookingsQuery';
import xbridgeQuery from './Queries/XbridgeQuery/BOGetXBridgeBookings.gql';
import shortid from 'shortid';
import { useQuery } from '@apollo/client';
import meQuery from './Queries/MeQuery/MeQuery.gql';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import {
  MeQuery,
  MeQueryVariables,
} from './Queries/MeQuery/_QueryTypes/MeQuery';
import optionQuery from '../../../../../Components/QueryComponents/AvenySYSOptionQuery/AvenySYSOptionQuery.gql';
import {
  AvenySYSOptionQuery,
  AvenySYSOptionQueryVariables,
} from '../../../../../Components/QueryComponents/AvenySYSOptionQuery/_QueryTypes/AvenySYSOptionQuery';
import {
  ResursQuery,
  ResursQueryVariables,
} from './Queries/ResursQuery/_QueryTypes/ResursQuery';
import {
  getDefaultBookingGroupName,
  getLoggedInResource,
} from './Utils/ResourceUtils';
import resursQuery from './Queries/ResursQuery/ResursQuery.gql';
import { ViewDbSettingsContext } from './Components/SchedulerComponent/ViewDbSettingsContext';
import mergeSort, { stringCompare } from '../../../../../Utils/mergeSort';
import {
  diffSec2,
  firstDayInMonth,
  firstDayInWeek,
  incDay,
  incMonth,
} from '../../../../../Utils/dateUtils';
import { dateToStr, tryStrToDateTime } from '../../../../../Utils/stringUtils';
import {
  IBookingType,
  IResource,
} from './Components/SchedulerComponent/Components/AppointmentComponent';
import { addDays } from 'date-fns';
import {
  getOneDayNameShortText,
  getOneDayNameText,
  isRedDay,
} from '../../../../../Utils/dayNames';
import { KalenderHeader } from './Components/KalenderHeader';
import {
  IBooking as INewBooking,
  IResource as INewResource,
} from '../../../../../BaseComponents/CalendarView/Utils/EDCalendarViewUtils';
import {
  EDCalendarView,
  TEDCalendarViewType,
} from '../../../../../BaseComponents/CalendarView/EDCalendarView';
import EDBox from '../../../../../BaseComponents/EDBox/EDBox';
import { firstUpper } from '../../../../../Utils/ramdaCookbook';
import { useTheme } from '@mui/material';
import { AktivitetTypCellMeny } from '../AktivitetTypCellMeny';
import { nyAktivitetInitialValues2 } from './Components/SchedulerComponent/Utils/NyAktivitetInitialValues';
import { RutinSettingsContext } from '../../../_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import { KalenderBookingPopup } from './Components/KalenderBookingPopup';
import { useIsSmallScreen } from '../../../../../Hooks/useFullscreenView';
import { Swipe } from 'react-swipe-component';
import EDAvenyProgress from '../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import { getActivityIcon } from './Utils/IconUtils';
import {
  FLOATING_MENU_CLEARANCE,
  useFloatingMenuReservedHeight,
} from '../../../../../Components/FloatingBottomArea/FloatingMenu';
import {
  SchedulerFilterContext,
  SchedulerFilterContextProvider,
} from './Components/SchedulerComponent/SchedulerFilterContext';
import { ICollectionDataType } from '../../../_Common/Components/BusinessCollectionComponents/Queries/BusinessCollectionQuery';
import {
  hasRutinKod,
  isReadOnlyRutin,
} from '../../ObjektVyer/Aktivitet/Utils/AktivitetUtils';
import { NewId } from '../../../../../Components/MasterDetail/MasterDetailUtils';
import { VirtuosoHandle } from 'react-virtuoso';

const compareDateTimeStrings = (dateTimeFr?: string, dateTimeTo?: string) =>
  diffSec2(
    tryStrToDateTime(dateTimeFr ?? '') ?? new Date(),
    tryStrToDateTime(dateTimeTo ?? '') ?? new Date()
  );

export const Kalender: React.FunctionComponent<
  React.PropsWithChildren<IExtendedBusinessDataProps>
> = props => {
  const loginStateContext = useContext(LoginStateContext);
  const activeRoutineContext = useContext(ActiveRoutineContext);
  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  const rutinSettingsContext = useContext(RutinSettingsContext);
  const viewDbSettingsContext = useContext(ViewDbSettingsContext);
  const parentSchedulerFilterContext = useContext(SchedulerFilterContext);
  const floatingMenuReservedHeight = useFloatingMenuReservedHeight();
  const setLoggedInUserResource = viewDbSettingsContext.setLoggedInUserResource;
  const currentDate = viewDbSettingsContext.currentDate ?? new Date();
  const setCurrentDate = viewDbSettingsContext.setCurrentDate;
  const currentView = viewDbSettingsContext.currentView ?? 'Week';
  const setCurrentView = viewDbSettingsContext.setCurrentView;
  const overView =
    viewDbSettingsContext.currentView === 'Day'
      ? viewDbSettingsContext.overView ?? false
      : false;
  const setOverView = viewDbSettingsContext.setOverView;
  const resources = viewDbSettingsContext.resources;
  const calendarSelection = viewDbSettingsContext.calendarSelection;
  const setCalendarSelection = viewDbSettingsContext.setCalendarSelection;
  const showOutlookBookings = viewDbSettingsContext.showOutlookBookings;
  const setShowOutlookBookings = viewDbSettingsContext.setShowOutlookBookings;
  const [menuOpen, setMenuOpen] = useState(false);
  const [bookingOpen, setBookingOpen] = useState<INewBooking | null>(null);
  const [popupRef, setPopupRef] = useState<EventTarget | null>(null);
  const [openDateCalender, setOpenDateCalender] = useState(false);
  const [scrolledDate, setScrolledDate] = useState<Date | undefined>();
  const theme = useTheme();
  const isSmallScreen = useIsSmallScreen();
  const listViewRef = React.useRef<VirtuosoHandle>(null);

  const { data: me_data, loading: me_loading } = useQuery<
    MeQuery,
    MeQueryVariables
  >(meQuery, {
    variables: {
      dbname: activeDatabaseContext.activeDatabase ?? '',
    },
    skip: !activeDatabaseContext.activeDatabase,
  });

  const { data: sysoption_data, loading: sysoption_loading } = useQuery<
    AvenySYSOptionQuery,
    AvenySYSOptionQueryVariables
  >(optionQuery, {
    fetchPolicy: 'cache-and-network',
    variables: {
      dbName: activeDatabaseContext.activeDatabase ?? '',
      subSystemCode: 'BO',
      optionKey: 'BO_NA_NEW_VIEWS',
    },
    skip: !activeDatabaseContext.activeDatabase,
  });

  const newViews =
    !sysoption_loading && sysoption_data?.db?.SYSOptions_All?.[0]?.OptionData
      ? sysoption_data?.db?.SYSOptions_All?.[0]?.OptionData.split(',')
      : [];
  const hasNewViews = newViews.length > 0;
  let oldView = false;
  let newView: TEDCalendarViewType | undefined = undefined;
  switch (currentView) {
    case 'Day':
    case 'Week':
    case 'Month':
      oldView = true;
      break;
    case 'Day2':
      newView = 'Day';
      break;
    case 'Week2':
      newView = 'Week';
      break;
    case 'Month2':
      newView = 'Month';
      break;
    default:
      newView = currentView as TEDCalendarViewType;
  }

  const defaultBookingGroup = getDefaultBookingGroupName(me_data);
  const { data: resurs_data } = useQuery<ResursQuery, ResursQueryVariables>(
    resursQuery,
    {
      variables: {
        dbname: activeDatabaseContext.activeDatabase ?? '',
        routineID: activeRoutineContext?.rutinInfo.rutinID,
        selectedBokningsgrupp: defaultBookingGroup ?? '',
      },
      skip:
        !defaultBookingGroup ||
        !activeDatabaseContext.activeDatabase ||
        me_loading,
    }
  );

  const loggedInResource = useMemo(
    () =>
      resurs_data
        ? getLoggedInResource(loginStateContext.sign, resurs_data)
        : undefined,
    [loginStateContext.sign, resurs_data]
  );
  useEffect(() => {
    setLoggedInUserResource(loggedInResource);
  }, [loggedInResource, setLoggedInUserResource]);

  const hasOnlyAktovrigtPermission = useMemo(() => {
    const hasKalenderPermission =
      hasRutinKod('rtnWebKalender', activeDatabaseContext.availableRoutines) &&
      !isReadOnlyRutin(
        'rtnWebKalender',
        activeDatabaseContext.availableRoutines
      );

    const hasGudstjanstPermission =
      hasRutinKod(
        'rtnWebBokaGudstjanst',
        activeDatabaseContext.availableRoutines
      ) &&
      !isReadOnlyRutin(
        'rtnWebBokaGudstjanst',
        activeDatabaseContext.availableRoutines
      );

    return hasKalenderPermission && !hasGudstjanstPermission;
  }, [activeDatabaseContext.availableRoutines]);

  const { data: xbridge_bookings } = useQuery<
    BOGetXBridgeBookingsQuery,
    BOGetXBridgeBookingsQueryVariables
  >(xbridgeQuery, {
    variables: {
      dbname: activeDatabaseContext.activeDatabase ?? '',
      startdatum:
        currentView === 'Month' || currentView === 'Month2'
          ? dateToStr(firstDayInWeek(firstDayInMonth(currentDate)))
          : dateToStr(firstDayInWeek(currentDate)),
      slutdatum:
        currentView === 'Month' || currentView === 'Month2'
          ? dateToStr(incDay(firstDayInWeek(firstDayInMonth(currentDate)), 41))
          : dateToStr(incDay(firstDayInWeek(currentDate), 6)),
      signatur:
        resources && resources.length > 0 ? undefined : loginStateContext.sign,
      resursId:
        resources && resources.length > 0
          ? resources.map(resInfo => resInfo.BO_RESURS_ID ?? '')
          : undefined,
    },
    skip: !showOutlookBookings,
  });

  // Filter Outlook bookings
  const filterOutlookEvents = React.useCallback(
    (outlookData: any[], searchText: string) => {
      if (!searchText || !outlookData) return outlookData || [];

      const searchLower = searchText.toLowerCase();

      return outlookData.filter(outlookItem => {
        const title = (outlookItem.titel || '').toLowerCase();
        const resourceName = (outlookItem.resursNamn || '').toLowerCase();
        const location = (outlookItem.plats || '').toLowerCase();

        return (
          title.includes(searchLower) ||
          resourceName.includes(searchLower) ||
          location.includes(searchLower)
        );
      });
    },
    []
  );

  const existingBookingKeys = useMemo(() => {
    const keys = new Set<string>();
    props.sortedData.rows?.forEach(item => {
      const key = [
        item.RESURS_NAMN,
        item._Associations?.Aktivitet?.TITEL,
        item._Associations?.Aktivitet?.FRANDATUM +
          ' ' +
          item._Associations?.Aktivitet?.FRANTID,
        item._Associations?.Aktivitet?.TILLDATUM +
          ' ' +
          item._Associations?.Aktivitet?.TILLTID,
      ].join('|');
      keys.add(key);
    });
    return keys;
  }, [props.sortedData.rows]);

  const isOutlookDuplicate = React.useCallback(
    (xbridgeItem: {
      resursNamn?: string | null;
      titel?: string | null;
      startdatum?: string | null;
      slutdatum?: string | null;
    }) => {
      const key = [
        xbridgeItem.resursNamn,
        xbridgeItem.titel,
        xbridgeItem.startdatum,
        xbridgeItem.slutdatum,
      ].join('|');
      return existingBookingKeys.has(key);
    },
    [existingBookingKeys]
  );

  const filteredOutlookEvents = useMemo(() => {
    if (!showOutlookBookings || !xbridge_bookings?.rtn?.BOGetXBridgeBookings) {
      return [];
    }

    const searchFiltered = filterOutlookEvents(
      xbridge_bookings.rtn.BOGetXBridgeBookings,
      parentSchedulerFilterContext.searchText || ''
    );

    return searchFiltered.filter(
      xbridgeItem => !isOutlookDuplicate(xbridgeItem)
    );
  }, [
    xbridge_bookings?.rtn?.BOGetXBridgeBookings,
    parentSchedulerFilterContext.searchText,
    showOutlookBookings,
    filterOutlookEvents,
    isOutlookDuplicate,
  ]);

  // Convert filtered Outlook bookings
  const outlookAsCollectionData = useMemo(() => {
    return filteredOutlookEvents.map(
      (outlookItem, index) =>
        ({
          id: `outlook-${index}-${outlookItem.resursId}`,
          TITEL: outlookItem.titel || '',
          RESURS_NAMN: outlookItem.resursNamn || '',
          FRANDATUM: outlookItem.startdatum?.split(' ')[0] || '',
          TILLDATUM: outlookItem.startdatum?.split(' ')[0] || '',
          FRANTID: outlookItem.startdatum?.split(' ')[1] || '',
          TILLTID: outlookItem.slutdatum?.split(' ')[1] || '',
          aktivityType: 'OUTLOOK',
          _isOutlookEvent: true,
          _outlookData: outlookItem,
          _version: 1,
        } as ICollectionDataType)
    );
  }, [filteredOutlookEvents]);

  // Combine filtered bokningsrubriker + filtered Outlook
  const combinedFilteredData = useMemo(
    () => ({
      rows: [...(props.sortedData.rows || []), ...outlookAsCollectionData],
      properties: props.sortedData.properties || [],
    }),
    [
      props.sortedData.rows,
      outlookAsCollectionData,
      props.sortedData.properties,
    ]
  );

  const totalFilteredCount = useMemo(() => {
    const activeBookingsCount =
      props.sortedData.rows?.filter(
        bokning => !bokning?._Associations?.Aktivitet?.BORTTAGEN
      ).length || 0;

    return activeBookingsCount + filteredOutlookEvents.length;
  }, [props.sortedData.rows, filteredOutlookEvents]);

  const totalUnfilteredCount =
    parentSchedulerFilterContext.listlength +
    (showOutlookBookings
      ? xbridge_bookings?.rtn?.BOGetXBridgeBookings?.length || 0
      : 0);

  const viewRangestartdatum =
    currentView === 'Month'
      ? firstDayInWeek(firstDayInMonth(currentDate))
      : firstDayInWeek(currentDate);
  const viewRangeslutdatum =
    currentView === 'Month'
      ? incDay(firstDayInWeek(firstDayInMonth(currentDate)), 41)
      : incDay(firstDayInWeek(currentDate), 6);

  const getdayNamesInRange = (startDate: Date, endDate: Date): Date[] => {
    let dayNames = [];
    let currentDate = startDate;
    while (currentDate <= endDate) {
      if (getOneDayNameText(currentDate)) {
        dayNames.push(new Date(currentDate));
      }
      currentDate = addDays(currentDate, 1);
    }
    return dayNames;
  };

  const getredDaysInRange = (startDate: Date, endDate: Date): Date[] => {
    let redDays = [];
    let currentDate = startDate;
    while (currentDate <= endDate) {
      if (isRedDay(currentDate)) {
        redDays.push(new Date(currentDate));
      }
      currentDate = addDays(currentDate, 1);
    }
    return redDays;
  };
  const redDays = getredDaysInRange(viewRangestartdatum, viewRangeslutdatum);
  // Used for XBridgeBookings
  const checkIfPerson = (id: string) => {
    const matchingResource = resources?.find(
      resource => resource.BO_RESURS_ID === id
    );
    return matchingResource?.basTyp === 'Person';
  };

  const bookingsObject = React.useMemo(() => {
    if (props.sortedData.rows) {
      const rows: IBokningsrubrik[] = props.sortedData.rows.filter(
        bokning => !bokning?._Associations?.Aktivitet?.BORTTAGEN
      ) as unknown as IBokningsrubrik[];

      let newBookingObject: BookingsObject = {};

      const dayNames = getdayNamesInRange(
        viewRangestartdatum,
        viewRangeslutdatum
      );
      if (dayNames) {
        dayNames.forEach(date => {
          const dayName = getOneDayNameShortText(date);
          newBookingObject[shortid()] = {
            title:
              dayName.substring(0, 1).toLocaleUpperCase() +
              dayName.substring(1),
            startDate: dateToStr(date),
            endDate: dateToStr(incDay(date, 1)),
            allDay: true,
            resourceName: '-',
            resourceNameList: [],
            bookingId: '-',
            activityId: '-',
            bookingNumber: '-',
            aktivityType: '-',
            bokningsbar: false,
            dayName: true,
            redDay: isRedDay(date),
          };
        });
      }

      rows.forEach(item => {
        const akt = item._Associations?.Aktivitet;
        const isMultiDay = item.FRANDATUM !== item.TILLDATUM;

        let id = '';
        if (isMultiDay) {
          id = `${akt?.id}`;
        } else if (overView) {
          id = `${akt?.id}_${item.RESURS_NAMN}_${item.FRANDATUM}_${item.FRANTID}_${item.TILLTID}`;
        } else {
          id = `${akt?.id}_${item.FRANDATUM}_${item.FRANTID}_${item.TILLTID}`;
        }

        if (newBookingObject[id]) {
          const item1 = newBookingObject[id];
          newBookingObject[id] = {
            ...item1,
            aktivityType: akt?._typ,
            resourceNameList: item1.resourceNameList?.concat([
              item.RESURS_NAMN,
            ]),
          };
        } else {
          const akttyp = akt?._typ;
          newBookingObject[id] = {
            title:
              akt?.TITEL ??
              (akttyp === 'GRAVSATTNING'
                ? 'Gravsättning'
                : akttyp
                ? akttyp[0].toUpperCase() + akttyp.slice(1).toLowerCase()
                : akttyp),
            startDate: isMultiDay
              ? item.FRANDATUM
              : item.FRANDATUM + ' ' + item.FRANTID,
            endDate: isMultiDay
              ? dateToStr(
                  incDay(tryStrToDateTime(item.TILLDATUM) ?? new Date(), 1)
                )
              : item.FRANDATUM + ' ' + item.TILLTID,
            location: {
              resName: akt?._Associations?.Resurs1?.RESURS_NAMN ?? '',
              resId: akt?._Associations?.Resurs1?.id ?? '',
            } as IResource,
            bookingId: item.id,
            bookingNumber: akt?.BOKNINGSNUMMER || '-',
            allDay: isMultiDay,
            aktStartDate: akt?.FRANDATUM + ' ' + akt?.FRANTID,
            aktEndDate: akt?.TILLDATUM + ' ' + akt?.TILLTID,
            resourceName: item.RESURS_NAMN,
            aktivityType: akttyp,
            activityId: akt?.id ?? '',
            activity: akt,
            prelBokad: akt?.PRELBOKAD,
            resourceNameList: [item.RESURS_NAMN],
            // bokningsbar: Boolean(akt?.Bokningsbar), Farlig långsam todo
            bokningsbar: true,
            bokningssignatur: akt?.BOKNINGSSIGNATUR ?? '',
          };
        }
      });

      if (filteredOutlookEvents.length > 0) {
        filteredOutlookEvents.forEach(xbridgeItem => {
          if (!isOutlookDuplicate(xbridgeItem))
            newBookingObject[shortid()] = {
              title: xbridgeItem.titel || '',
              startDate: xbridgeItem.startdatum,
              endDate: xbridgeItem.slutdatum,
              aktStartDate: xbridgeItem.startdatum,
              aktEndDate: xbridgeItem.slutdatum,
              resourceName: xbridgeItem.resursNamn,
              resourceNameList: [xbridgeItem.resursNamn],
              bookingId: '-',
              activityId: '-',
              bookingNumber: '-',
              aktivityType: 'OUTLOOK',
              bokningsbar: false,
              isPerson: checkIfPerson(xbridgeItem.resursId || ''),
              location: {
                resName: xbridgeItem.plats,
                resId: xbridgeItem.resursId,
              } as IResource,
            };
        });
      }

      const newBookingList = mergeSort(
        Object.values(newBookingObject),
        (item1, item2) => {
          let comp = 0;
          if (overView && comp === 0) {
            comp = stringCompare(
              item1.resourceName ?? '',
              item2.resourceName ?? ''
            );
          }
          if (comp === 0) {
            comp = -compareDateTimeStrings(item1.startDate, item2.startDate);
          }
          return comp;
        }
      );

      let currentGroup: IBookingType[] = [];
      let currentGroupEnd = '';
      let currentGroupWidth = 1;
      let currentResName = '';
      newBookingList.forEach(item => {
        if (!item.allDay && !item.redDay && !item.dayName)
          if (
            currentGroupEnd === '' ||
            compareDateTimeStrings(currentGroupEnd, item.startDate) >= 0 ||
            (overView &&
              stringCompare(currentResName, item.resourceName ?? '') !== 0)
          ) {
            currentGroup.forEach(
              grpItem => (grpItem.groupWidth = currentGroupWidth)
            );
            currentGroup = [item];
            currentGroupEnd = item.endDate;
            currentGroupWidth = 1;
            item.groupOffset = 0;
            item.groupWidth = 1;
            currentResName = item.resourceName ?? '';
          } else {
            item.groupOffset = currentGroupWidth;
            for (
              let groupOffset = 0;
              groupOffset < currentGroupWidth;
              groupOffset++
            ) {
              if (
                !currentGroup.find(
                  grpItem =>
                    compareDateTimeStrings(grpItem.endDate, item.startDate) <
                      0 && (grpItem.groupOffset ?? 0) === groupOffset
                )
              ) {
                item.groupOffset = groupOffset;
                break;
              }
            }
            if (item.groupOffset >= currentGroupWidth) {
              currentGroupWidth = item.groupOffset + 1;
            }

            currentGroup.push(item);
            if (item.endDate > currentGroupEnd) {
              currentGroupEnd = item.endDate;
            }
          }
      });
      currentGroup.forEach(item => {
        if (!item.allDay && !item.redDay && !item.dayName) {
          item.groupWidth = currentGroupWidth;
        }
      });

      return newBookingObject;
    }
    return {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.sortedData.rows,
    filteredOutlookEvents,
    viewRangestartdatum,
    viewRangeslutdatum,
    overView,
  ]);

  const getBackgroundColor = (
    isNewView: boolean,
    prel: boolean,
    akttyp: string
  ) => {
    if (isNewView && prel) {
      return (
        theme.customProperties.AktivitetColors
          .preliminarNyVy as unknown as Record<string, string>
      )[akttyp];
    }
    if (!isNewView && prel) {
      return (
        theme.customProperties.AktivitetColors.preliminar as unknown as Record<
          string,
          string
        >
      )[akttyp];
    }
    return (
      theme.customProperties.AktivitetColors as unknown as Record<
        string,
        string
      >
    )[akttyp];
  };

  const getBackgroundColorLight = (
    isNewView: boolean,
    prel: boolean,
    akttyp: string
  ) => {
    if (isNewView && prel) {
      return (
        theme.customProperties.AktivitetColors.preliminarNyVy
          .light as unknown as Record<string, string>
      )[akttyp];
    }
    if (!isNewView && prel) {
      return (
        theme.customProperties.AktivitetColors.preliminar
          .light as unknown as Record<string, string>
      )[akttyp];
    }
    return (
      theme.customProperties.AktivitetColors.light as unknown as Record<
        string,
        string
      >
    )[akttyp];
  };

  // NEW calendar view
  // BOBokningsrubrik är som aktivitet fast kan avvika för just denna resurs.
  // startTime2/endTime2 används för att skilja på ställtid
  const newBookings: INewBooking[] = React.useMemo(() => {
    let bookings: INewBooking[] = [];
    if (hasNewViews && props.sortedData?.rows) {
      props.sortedData.rows
        .filter(bokning => !bokning?._Associations?.Aktivitet?.BORTTAGEN)
        .forEach(row => {
          const akt = row._Associations?.Aktivitet;

          // Rubrik's own span — this is what determines calendar placement
          const startTime = tryStrToDateTime(row.FRANDATUM + ' ' + row.FRANTID);
          const endTime = tryStrToDateTime(row.TILLDATUM + ' ' + row.TILLTID);

          // Aktivitet's span — used for the activity time indicator
          const aktStartTime = tryStrToDateTime(
            akt?.FRANDATUM + ' ' + akt?.FRANTID
          );
          const aktEndTime = tryStrToDateTime(
            akt?.TILLDATUM + ' ' + akt?.TILLTID
          );

          // startTime2/endTime2: show ställtid if the rubrik's span differs
          // from the aktivitet's span, otherwise show the aktivitet time.
          const startTime2 =
            row.FRANDATUM !== akt?.FRANDATUM || row.FRANTID !== akt?.FRANTID
              ? tryStrToDateTime(row.FRANDATUM + ' ' + row.FRANTID)
              : aktStartTime;
          const endTime2 =
            row.TILLDATUM !== akt?.TILLDATUM || row.TILLTID !== akt?.TILLTID
              ? tryStrToDateTime(row.TILLDATUM + ' ' + row.TILLTID)
              : aktEndTime;

          const akttyp: string = akt?._typ?.toLowerCase() ?? 'aktovrigt';
          const prel = akt?.PRELBOKAD;

          if (startTime && endTime) {
            bookings.push({
              bookingId: row.id,
              startTime: startTime,
              endTime: endTime,
              startTime2: startTime2 || startTime,
              endTime2: endTime2 || endTime,
              aktId: akt?.id,
              aktTyp: akt?._typ,
              aktBokningssignatur: akt?.BOKNINGSSIGNATUR,
              aktStartTime: aktStartTime,
              aktEndTime: aktEndTime,
              allDay: row.FRANDATUM !== row.TILLDATUM,
              aktCaption:
                akt?.TITEL ??
                (akttyp === 'gravsattning'
                  ? 'Gravsättning'
                  : akttyp === 'aktovrigt'
                  ? 'Övrig aktivitet'
                  : firstUpper(akttyp)),
              aktLocation: akt?._Associations?.Resurs1?.RESURS_NAMN,
              // resourceId comes directly from the rubrik's own Resurs association
              resourceId: row._Associations?.Resurs?.BO_RESURS_ID,
              color: (
                theme.customProperties.AktivitetColors as unknown as Record<
                  string,
                  string
                >
              )[akttyp],
              background: getBackgroundColor(hasNewViews, prel, akttyp),
              backgroundLight: getBackgroundColorLight(
                hasNewViews,
                prel,
                akttyp
              ),
              shadowBackground: (
                theme.customProperties.AktivitetColors
                  .stalltid as unknown as Record<string, string>
              )[akttyp],
              icon: getActivityIcon(akt, false),
              prelBokad: akt?.PRELBOKAD,
              Bokningsnummer: akt?.BOKNINGSNUMMER,
              Huvudakt: akt?.Huvudakt,
              Resursrubrik: row?.Resursrubrik,
            });
          }
        });
    }
    if (hasNewViews && filteredOutlookEvents.length > 0) {
      filteredOutlookEvents.forEach(xbridgeItem => {
        if (!isOutlookDuplicate(xbridgeItem)) {
          const startTime = tryStrToDateTime(xbridgeItem.startdatum);
          const endTime = tryStrToDateTime(xbridgeItem.slutdatum);
          if (startTime && endTime) {
            bookings.push({
              startTime: startTime,
              endTime: endTime,
              startTime2: startTime,
              endTime2: endTime,
              aktId: `${xbridgeItem.titel ?? 'Outlookbokning'}|${
                xbridgeItem.resursId ?? ''
              }`,
              aktTyp: 'OUTLOOK',
              resourceName: xbridgeItem.resursNamn,
              aktLocation: xbridgeItem.plats ?? undefined,
              isPerson: checkIfPerson(xbridgeItem.resursId || ''),
              aktCaption: xbridgeItem.titel ?? 'Outlookbokning',
              resourceId: xbridgeItem.resursId ?? undefined,
              color: theme.customProperties.AktivitetColors.outlook,
              backgroundLight: xbridgeItem.preliminar
                ? theme.customProperties.AktivitetColors.preliminar.light
                    .outlook
                : theme.customProperties.AktivitetColors.light.outlook,
              background: xbridgeItem.preliminar
                ? theme.customProperties.AktivitetColors.preliminar.outlook
                : theme.customProperties.AktivitetColors.outlook,
              prelBokad: xbridgeItem._Associations?.Aktivitet?.PRELBOKAD,
            });
          }
        }
      });
    }

    return bookings;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    hasNewViews,
    props.sortedData.rows,
    filteredOutlookEvents,
    theme.customProperties.AktivitetColors,
  ]);

  const allDayBookings = useMemo(
    () =>
      newBookings
        .filter((booking, index) => {
          return (
            booking.allDay === true &&
            newBookings.findIndex(b => b.aktId === booking.aktId) === index
          );
        })
        .sort((a, b) => {
          const dateA = new Date(a.aktStartTime || 0);
          const dateB = new Date(b.aktStartTime || 0);
          return dateA.getTime() - dateB.getTime();
        }),
    [newBookings]
  );

  const regularBookings = useMemo(
    () => newBookings.filter(booking => booking.allDay !== true),
    [newBookings]
  );

  const newResources: INewResource[] = React.useMemo(() => {
    return hasNewViews && resources && resources.length > 0
      ? resources.map(res => ({
          id: res.BO_RESURS_ID ?? '',
          name: res.resName,
        }))
      : hasNewViews && loggedInResource
      ? [
          {
            id: loggedInResource?.BO_RESURS_ID ?? '',
            name: loggedInResource?.resName,
          },
        ]
      : [];
  }, [hasNewViews, resources, loggedInResource]);

  const onSwipeLeftListener = () => {
    switch (currentView) {
      case 'Week':
      case 'Week2':
      case 'WorkWeek':
      case 'WeekOverview':
      case 'WeekOverview2':
        setCurrentDate(incDay(currentDate, 7));
        break;
      case 'Month':
      case 'Month2':
        setCurrentDate(incMonth(currentDate, 1));
        break;
      default:
        setCurrentDate(incDay(currentDate, 1));
        break;
    }
  };
  const onSwipeRightListener = () => {
    switch (currentView) {
      case 'Week':
      case 'Week2':
      case 'WorkWeek':
      case 'WeekOverview':
      case 'WeekOverview2':
        setCurrentDate(incDay(currentDate, -7));
        break;
      case 'Month':
      case 'Month2':
        setCurrentDate(incMonth(currentDate, -1));
        break;
      default:
        setCurrentDate(incDay(currentDate, -1));
        break;
    }
  };

  const showNewHeader = hasNewViews && (!oldView || !isSmallScreen);

  const dayCount =
    newView === 'Day'
      ? 1
      : newView === 'WorkWeek'
      ? 5
      : newView === 'List'
      ? 14
      : 7;

  useMemo(() => {
    viewDbSettingsContext.setDayCount(dayCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentView]);

  const handleSelectionChange = React.useCallback(
    (
      selectedStartTime: Date | undefined,
      selectedEndTime: Date | undefined,
      selectedResources: string[] | undefined
    ) => {
      const useTime = ['Day2', 'Week2', 'WorkWeek', 'DayOverview'].includes(
        currentView
      );

      const shouldSkipResourcePrefill =
        ['Day2', 'Week2', 'Month2', 'WorkWeek'].includes(currentView) &&
        resources &&
        resources.length > 1;

      viewDbSettingsContext.setNyAktivitetInitialValues(
        nyAktivitetInitialValues2(
          selectedStartTime,
          selectedEndTime ?? selectedStartTime,
          selectedResources,
          shouldSkipResourcePrefill
            ? undefined
            : resources && resources.length > 0
            ? resources
            : loggedInResource
            ? [loggedInResource]
            : undefined,
          useTime,
          rutinSettingsContext,
          me_data?.me?.[0]?.bokningsgrupper ?? undefined
        )
      );
    },
    [
      currentView,
      resources,
      loggedInResource,
      viewDbSettingsContext,
      rutinSettingsContext,
      me_data,
    ]
  );

  const handleSelectionClick = React.useCallback(
    (ref: EventTarget) => {
      setPopupRef(ref);
      if (hasOnlyAktovrigtPermission) {
        if (props.selectDetail) {
          props.selectDetail({ id: NewId, customDetailData: 'AKTOVRIGT' });
        }
      } else {
        setMenuOpen(true);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hasOnlyAktovrigtPermission, props.selectDetail]
  );

  const handleBookingClick = React.useCallback(
    (ref: EventTarget, booking: INewBooking) => {
      setPopupRef(ref);
      setBookingOpen(booking);
    },
    []
  );

  return sysoption_loading ? (
    <EDBox
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent',
      }}
    >
      <EDAvenyProgress overlay />
    </EDBox>
  ) : (
    <SchedulerFilterContextProvider
      onSearchTextChanged={parentSchedulerFilterContext.onSearchTextChanged}
      searchText={parentSchedulerFilterContext.searchText}
      filterAttributes={parentSchedulerFilterContext.filterAttributes}
      sortedData={combinedFilteredData}
      listlength={totalUnfilteredCount}
      sortedLength={totalFilteredCount}
      visningsTyp={parentSchedulerFilterContext.visningsTyp}
    >
      <>
        {showNewHeader && (
          <KalenderHeader
            currentDate={currentDate}
            setCurrentDate={setCurrentDate}
            currentView={currentView}
            setCurrentView={setCurrentView}
            views={newViews}
            showOutlookBookings={showOutlookBookings}
            setShowOutlookBookings={setShowOutlookBookings}
            anchorEl={popupRef as HTMLElement}
            setOpenDateCalender={setOpenDateCalender}
            openDateCalender={openDateCalender}
            onDateCalenderClick={(ref: EventTarget) => {
              setPopupRef(ref);
            }}
            isSmallScreen={isSmallScreen}
            scrolledDate={scrolledDate}
            listViewRef={listViewRef}
          />
        )}

        {oldView || !hasNewViews ? (
          <SchedulerComponent
            bookingsObject={bookingsObject}
            resources={
              resources && resources.length > 0
                ? resources
                : loggedInResource
                ? [loggedInResource]
                : undefined
            }
            redDays={redDays}
            messages={'sv-SV'}
            firstDayOfWeek={1}
            dayViewDisplayName={'Dag'}
            weekViewDisplayName={'Vecka'}
            monthViewDisplayName={'Månad'}
            currentDate={currentDate}
            onCurrentDateChange={setCurrentDate}
            currentView={currentView}
            onCurrentViewChange={setCurrentView}
            weekViewCellDuration={60}
            dayViewCellDuration={60}
            overView={overView}
            onOverViewChange={setOverView}
            selectDetail={props.selectDetail}
            bookingGroups={me_data}
            showHeader={!showNewHeader}
            showViewSwitcher={!hasNewViews}
            showOutlookBookings={showOutlookBookings}
            setShowOutlookBookings={setShowOutlookBookings}
          />
        ) : (
          <EDBox
            sx={{
              width: '100%',
              height: '100%',
              overflow: 'hidden',
            }}
          >
            {currentView !== 'DayOverview' &&
            currentView !== 'WeekOverview' &&
            currentView !== 'List' ? (
              <Swipe
                onSwipedLeft={onSwipeLeftListener}
                onSwipedRight={onSwipeRightListener}
                detectTouch={true}
                style={{
                  height: '100%',
                  overflowY: 'hidden',
                }}
                detectMouse={isSmallScreen ? true : false}
              >
                <EDCalendarView
                  view={newView ?? 'Week'}
                  bookings={newBookings}
                  allDayBookings={allDayBookings}
                  regularBookings={regularBookings}
                  resources={newResources}
                  selection={calendarSelection}
                  setSelection={setCalendarSelection}
                  currentDate={currentDate}
                  onSelectionChange={handleSelectionChange}
                  onSelectionClick={handleSelectionClick}
                  onBookingClick={handleBookingClick}
                  onScrolledDateChange={setScrolledDate}
                  bottomSpacing={
                    props.floatingMenuBottomSpacing
                      ? FLOATING_MENU_CLEARANCE
                      : undefined
                  }
                  bottomInsetPx={
                    props.floatingMenuBottomSpacing
                      ? floatingMenuReservedHeight
                      : undefined
                  }
                />
              </Swipe>
            ) : (
              <EDCalendarView
                view={newView ?? 'Week'}
                bookings={newBookings}
                allDayBookings={allDayBookings}
                regularBookings={regularBookings}
                resources={newResources}
                selection={calendarSelection}
                setSelection={setCalendarSelection}
                currentDate={currentDate}
                onSelectionChange={handleSelectionChange}
                listViewRef={listViewRef}
                onSelectionClick={handleSelectionClick}
                onBookingClick={handleBookingClick}
                onScrolledDateChange={setScrolledDate}
                bottomSpacing={
                  props.floatingMenuBottomSpacing
                    ? FLOATING_MENU_CLEARANCE
                    : undefined
                }
                bottomInsetPx={
                  props.floatingMenuBottomSpacing
                    ? floatingMenuReservedHeight
                    : undefined
                }
              />
            )}

            {menuOpen && popupRef && (
              <AktivitetTypCellMeny
                anchorEl={popupRef as HTMLElement}
                open={true}
                onClose={() => {
                  setMenuOpen(false);
                }}
                onSelectDetail={id => {
                  setCalendarSelection(undefined);
                  if (props.selectDetail) {
                    props.selectDetail(id);
                  }
                }}
              />
            )}
            {bookingOpen && popupRef && (
              <KalenderBookingPopup
                open={true}
                onClose={() => {
                  setBookingOpen(null);
                }}
                onSelectDetail={id => {
                  setCalendarSelection(undefined);
                  if (props.selectDetail) {
                    props.selectDetail(id);
                  }
                }}
                anchorEl={popupRef as HTMLElement}
                booking={bookingOpen}
              />
            )}
          </EDBox>
        )}
      </>
    </SchedulerFilterContextProvider>
  );
};
